import type {
  FlexibleContentCardConfig,
  FlexibleContentCardResolved,
} from './types';

// Shared defaulting/normalisation for the card, called from both container
// widgets' `resolveSync`. Extracted into its own module (rather than inlined
// in an `index.ts`, as `navigation-grid` does) because it has two callers.
export function resolveFlexibleContentCard(
  config: FlexibleContentCardConfig,
): FlexibleContentCardResolved {
  return {
    id: config.id ?? 0,
    spanColumns: config.spanColumns ?? '1',
    kicker: config.kicker ?? null,
    title: config.title ?? null,
    titleLink: config.titleLink ?? null,
    titlePower: config.titlePower ?? '3',
    visualOnly: config.visualOnly ?? false,
    videoUrl: config.videoUrl ?? null,
    image: config.image ?? null,
    imageShape: config.imageShape ?? 'rounded',
    iconDesktop: config.iconDesktop ?? null,
    iconMobile: config.iconMobile ?? null,
    mediaPlacement: config.mediaPlacement ?? 'inline',
    text: config.text ?? null,
    alignment: config.alignment ?? 'center',
    ctaLabel: config.ctaLabel ?? null,
    ctaLink: config.ctaLink ?? null,
    ctaPhone: config.ctaPhone ?? null,
    ctaMatelsoPhoneLabel: config.ctaMatelsoPhoneLabel ?? null,
    ctaStyle: config.ctaStyle ?? 'textlink',
    hasPlzFinder: config.hasPlzFinder ?? false,
    // Non-repeatable component zone — pass the raw block(s) straight through
    // for `SlotRenderer`; coerce anything that is not an array to empty, the
    // same way `tracking` guards its free-form column below.
    expandable: Array.isArray(config.expandable) ? config.expandable : [],
    // `tracking` is the `global::event-tracking` JSON column — free-form and
    // nullable, so coerce anything that is not an array to an empty list.
    tracking: Array.isArray(config.tracking) ? config.tracking : [],
  };
}
